import { Box, Chip, ChipDelete } from "@mui/joy";
import DarkCard from "../../../common/DarkCard";
import DarkTypography from "../../../common/DarkTypography";
import IconButtonCTA from "../../../common/IconButtonCTA";
import { SCreate, SDelete } from "../../../../styles/StyledMUI";
import GoogleGroupsPickMenu from "./GoogleGroupsPickMenu";

type GoogleGroupCardProps = {
  label: string;
  qualifications: string[];
  canEdit: boolean;
  availableQualifications: string[];
  onRemoveQualification: (label: string, qualification: string) => void;
  onAddQualification: (label: string, qualification: string) => void;
  onRemoveGroup: (label: string) => void;
  getQualificationLabel: (qualification: string) => string;
};

export default function GoogleGroupCard(props: GoogleGroupCardProps) {
  const {
    label,
    qualifications,
    canEdit,
    availableQualifications,
    onRemoveQualification,
    onAddQualification,
    onRemoveGroup,
    getQualificationLabel,
  } = props;

  return (
    <DarkCard dense sx={{ maxWidth: "100%" }}>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gap: 1,
          mb: { xs: 1.25, sm: 1.5 },
          minWidth: 0,
        }}
      >
        <DarkTypography
          level="title-sm"
          colorVariant="title"
          sx={{ minWidth: 0, flex: "1 1 auto" }}
        >
          {label}
        </DarkTypography>
        {canEdit ? (
          <Box sx={{ display: "flex", gap: 0.5, flexShrink: 0 }}>
            <GoogleGroupsPickMenu
              items={availableQualifications}
              ariaLabel={`Ajouter une qualification à ${label}`}
              onPick={(qualification) => onAddQualification(label, qualification)}
              getItemLabel={getQualificationLabel}
            >
              <SCreate />
            </GoogleGroupsPickMenu>
            <IconButtonCTA
              ctaVariant="danger"
              aria-label={`Retirer ${label}`}
              onClick={() => onRemoveGroup(label)}
            >
              <SDelete />
            </IconButtonCTA>
          </Box>
        ) : null}
      </Box>

      <Box display="flex" flexWrap="wrap" alignItems="center" gap={1} sx={{ minWidth: 0 }}>
        {qualifications.map((qualification) => (
          <Chip
            key={qualification}
            size="sm"
            variant="soft"
            endDecorator={
              canEdit ? (
                <ChipDelete onDelete={() => onRemoveQualification(label, qualification)} />
              ) : undefined
            }
          >
            {getQualificationLabel(qualification)}
          </Chip>
        ))}
      </Box>
    </DarkCard>
  );
}
